/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ConceptClusterDescription } from './conceptClusterDescription';

/**
 * A semantic grouping of concepts.
 */
export interface ConceptCluster {
  id: string;
  label: string;
  description?: ConceptClusterDescription;
}
